module.exports = __webpack_public_path__ + "img/withdraw.c85db422.svg";